module.exports = __webpack_public_path__ + "assets/img/ggg.d5c11376.png";